var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],ref:"readingInput",attrs:{"type":"text"},domProps:{"value":(_vm.value)},on:{"input":[function($event){if($event.target.composing)return;_vm.value=$event.target.value},_vm.setReading]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }